import { h, JSX } from 'preact'
// import { IVatPickerProps } from './types'

export default function VatPicker({
    vats,
    className,
}) {
    const setVat = (url) => {
        try {
            fetch(url).then(res => {
                if (res.status === 200) window.location.reload()
            })
        } catch (ex) {
            //
        }
    }

    return (
        <div className={className ?? 'vat-types'}>
            {!!vats?.length &&
                vats.map(vat => (
                    <span
                        onClick={() => setVat(vat.fetchUrl)}
                        style={'cursor: pointer'}
                    >
                        {vat.isSelected ? (
                            <strong>{vat.text}</strong>
                        ) : (
                            vat.text
                        )}
                    </span>
                ))}
        </div>
    )
}
